import React from "react"

import TemplateInsurance from "Components/UI/Templates/TemplateInsurance"

const HomeInsurance = () => {
  return <TemplateInsurance />
}

export default HomeInsurance
